import { render, staticRenderFns } from "./WishlistCardForBrand.vue?vue&type=template&id=b5d22ba8&"
import script from "./WishlistCardForBrand.vue?vue&type=script&lang=js&"
export * from "./WishlistCardForBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports